module.exports = __webpack_public_path__ + "static/media/steel.d7e747d5.jpg";